import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createConfig, http, WagmiProvider } from 'wagmi'
import { base, baseSepolia } from 'wagmi/chains'
import { ReactNode } from 'react'
import { appChain } from '@/lib/chain'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
    },
  },
})

const baseRpcUrl = import.meta.env.VITE_BASE_RPC_URL ?? 'https://mainnet.base.org'
const baseSepoliaRpcUrl = import.meta.env.VITE_BASE_SEPOLIA_RPC_URL ?? 'https://sepolia.base.org'

const config =
  appChain.id === baseSepolia.id
    ? createConfig({
        chains: [baseSepolia],
        transports: {
          [baseSepolia.id]: http(baseSepoliaRpcUrl),
        },
      })
    : createConfig({
        chains: [base],
        transports: {
          [base.id]: http(baseRpcUrl),
        },
      })

export function AppProvider({ children }: { children: ReactNode }) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  )
}
